import React from 'react';
import { Language } from '../../utils/i18n';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { lang, setLang } = useLanguage();

  const handleLanguageChange = (newLang: Language) => {
    setLang(newLang);
  };

  return (
    <div className="language-switcher">
      <button
        type="button"
        className={`language-switcher__btn ${lang === 'ru' ? 'language-switcher__btn--active' : ''}`}
        onClick={() => handleLanguageChange('ru')}
      >
        RU
      </button>
      <button
        type="button"
        className={`language-switcher__btn ${lang === 'en' ? 'language-switcher__btn--active' : ''}`}
        onClick={() => handleLanguageChange('en')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
